import { getApps, initializeApp } from 'firebase/app';
import {
  AuthProvider,
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
} from 'firebase/auth';
import { OAuthProviders } from '~/types';

const isDev = import.meta.env.DEV;

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: isDev
    ? import.meta.env.VITE_FIREBASE_AUTH_DOMAIN
    : window.location.hostname,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account',
  access_type: 'offline',
  response_type: 'code',
});

export const providers: Record<OAuthProviders, AuthProvider> = {
  Google: googleProvider,
  Apple: new OAuthProvider('apple.com'),
};

export const providerMap: Record<string, OAuthProviders> = {
  'google.com': 'Google',
  'apple.com': 'Apple',
};
